// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"99b26a85","573":"a1585ba4"}[chunkId] + ".chunk.js";
};